"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WatermarkManifest = void 0;
/**
 * WatermarkManifest
 * @doc WatermarkManifest
 */
var WatermarkManifest = /** @class */ (function () {
    function WatermarkManifest(data) {
        /**
         * @description a system assigned unique id
         */
        this.id = '';
        this.id = data.id;
    }
    return WatermarkManifest;
}());
exports.WatermarkManifest = WatermarkManifest;
//# sourceMappingURL=watermark-manifest.js.map